import { render, staticRenderFns } from "./VTextAreaWithValidation.vue?vue&type=template&id=b10e2c74&"
import script from "./VTextAreaWithValidation.vue?vue&type=script&lang=js&"
export * from "./VTextAreaWithValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports